import React, { FC } from 'react'
import GridPageHeader from '@components/blocks/GridPageHeader'
import { ExtraControlButton } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'
import { useCurrentPage } from '@hooks/useCurrentPage'

type Props = {
  heading?: React.ReactNode
  description?: React.ReactNode
  breadcrumbsItems?: string
  eshopId?: string
  error?: Error
  icon?: React.ReactElement
  children?: React.ReactNode
  itemsCount?: number
  $flexCol?: boolean
  extraControlButtons?: ExtraControlButton[]
}

/**
 * Container which extracts data from current main menu
 * @returns header with Heading, heading detail & related tabs as links
 */
const MenuPageHeader: FC<Props> = ({ heading, description, error, extraControlButtons, eshopId, ...props }) => {
  const currentPage = useCurrentPage(eshopId)

  return (
    <GridPageHeader
      heading={heading ?? <>{currentPage?.title || ''}</>}
      description={description ?? (currentPage?.description || '')}
      error={error}
      extraControlButtons={extraControlButtons}
      eshopId={eshopId}
      {...props}
    />
  )
}

export default MenuPageHeader
